const DollarIcon = function DollarIcon() {
  return (
    <svg
      className="fin-state"
      width="27px"
      height="28px"
      viewBox="0 0 27 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Shape</title>
      <g id="Dev-Ready-prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Company_Financials" transform="translate(-210.000000, -1580.000000)" fill="#7E7E7E" fillRule="nonzero">
          <g id="Group-6" transform="translate(175.000000, 881.000000)">
            <g id="Group-8" transform="translate(0.364244, 668.000000)">
              <g id="paid_black_24dp" transform="translate(29.000000, 29.000000)">
                <path d="M19,2.66666667 C11.64,2.66666667 5.66666667,8.64 5.66666667,16 C5.66666667,23.36 11.64,29.3333333 19,29.3333333 C26.36,29.3333333 32.3333333,23.36 32.3333333,16 C32.3333333,8.64 26.36,2.66666667 19,2.66666667 Z M19,26.6666667 C13.12,26.6666667 8.33333333,21.88 8.33333333,16 C8.33333333,10.12 13.12,5.33333333 19,5.33333333 C24.88,5.33333333 29.6666667,10.12 29.6666667,16 C29.6666667,21.88 24.88,26.6666667 19,26.6666667 Z M20.1866667,14.8 C17.8133333,14.0133333 16.6666667,13.52 16.6666667,12.2666667 C16.6666667,10.9066667 18.1466667,10.4133333 19.08,10.4133333 C20.8266667,10.4133333 21.4666667,11.7333333 21.6133333,12.2 L23.72,11.3066667 C23.52,10.72 22.6266667,8.76 20.1733333,8.33333333 L20.1733333,6.66666667 L17.84,6.66666667 L17.84,8.34666667 C14.3733333,9.09333333 14.3466667,12.1466667 14.3466667,12.2933333 C14.3466667,15.32 17.3466667,16.1733333 18.8133333,16.7066667 C20.92,17.4533333 21.8533333,18.1333333 21.8533333,19.4133333 C21.8533333,20.92 20.4533333,21.56 19.2133333,21.56 C16.7866667,21.56 16.0933333,19.0666667 16.0133333,18.7733333 L13.8,19.6666667 C14.64,22.5866667 16.84,23.3733333 17.8266667,23.6133333 L17.8266667,25.3333333 L20.16,25.3333333 L20.16,23.68 C20.8533333,23.56 24.1866667,22.8933333 24.1866667,19.3866667 C24.2,17.5333333 23.3866667,15.9066667 20.1866667,14.8 Z" id="Shape" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DollarIcon;
